export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[620px] md:min-h-[680px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-0 right-0 w-[900px] h-[900px] rounded-full bg-primary-500/5 blur-[120px] -translate-y-1/2 translate-x-1/4"></div>
        <div className="absolute bottom-0 left-0 w-[600px] h-[600px] rounded-full bg-accent-500/4 blur-[100px] translate-y-1/2 -translate-x-1/4"></div>
      </div>

      <div className="relative w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 w-full text-center lg:text-left pt-20 md:pt-24 lg:pt-0">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-500/15 text-accent-400 text-xs font-medium mb-5 whitespace-nowrap">
              <i className="ri-fire-fill text-sm"></i>
              每日更新 · 海量片库
            </span>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-4">
              人人影院
              <span className="block text-primary-500">免费高清在线观看平台</span>
            </h1>

            <p className="text-lg text-primary-400 font-heading mb-5 tracking-wide">
              最新电影电视剧 · 不缓冲流畅追剧
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-[560px] mx-auto lg:mx-0 mb-7">
              人人影院汇聚海量高清影视资源，涵盖最新院线大片、热门电视剧全集、经典老片与热门综艺。
              所有影片无需注册即可在线观看，采用智能加速技术确保流畅播放不卡顿，
              每日同步更新最新内容，追剧看片一站搞定。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-7 mb-8">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500/15">
                  <i className="ri-film-line text-primary-500 text-sm"></i>
                </div>
                <div className="text-left">
                  <div className="text-sm font-bold text-foreground-950 whitespace-nowrap">10万+</div>
                  <div className="text-xs text-foreground-600 whitespace-nowrap">影视资源</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-500/15">
                  <i className="ri-flashlight-line text-accent-500 text-sm"></i>
                </div>
                <div className="text-left">
                  <div className="text-sm font-bold text-foreground-950 whitespace-nowrap">1080P</div>
                  <div className="text-xs text-foreground-600 whitespace-nowrap">高清画质</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-500/15">
                  <i className="ri-timer-line text-secondary-500 text-sm"></i>
                </div>
                <div className="text-left">
                  <div className="text-sm font-bold text-foreground-950 whitespace-nowrap">每日更新</div>
                  <div className="text-xs text-foreground-600 whitespace-nowrap">同步追剧</div>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#carousel"
                className="w-full sm:w-auto px-7 py-3 rounded-lg text-sm font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap text-center"
              >
                <i className="ri-play-circle-fill mr-1.5"></i>开始观影
              </a>
              <a
                href="#ranking"
                className="w-full sm:w-auto px-7 py-3 rounded-lg text-sm font-medium text-foreground-700 border border-background-300 hover:text-foreground-950 hover:border-foreground-400 transition-colors cursor-pointer whitespace-nowrap text-center"
              >
                <i className="ri-fire-line mr-1.5"></i>查看热播榜
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-[520px] pt-4 lg:pt-20">
            <div className="relative">
              <div className="absolute -inset-4 rounded-2xl bg-primary-500/10 blur-2xl"></div>
              <div className="relative grid grid-cols-2 gap-3">
                <img
                  src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20style%20image%20of%20a%20dramatic%20film%20scene%20with%20warm%20golden%20lighting%2C%20mysterious%20silhouette%20figure%20in%20the%20foreground%2C%20urban%20cityscape%20at%20night%20in%20the%20background%2C%20film%20grain%20texture%2C%20dark%20cinematic%20color%20grading%20with%20amber%20accents%2C%20professional%20movie%20poster%20composition%2C%20high%20contrast%20lighting%2C%20no%20text&width=600&height=800&seq=hero-poster-01&orientation=portrait"
                  alt="热播电影推荐"
                  className="w-full aspect-[3/4] object-cover rounded-xl"
                />
                <div className="flex flex-col gap-3">
                  <img
                    src="https://readdy.ai/api/search-image?query=Cinematic%20drama%20film%20still%20with%20two%20characters%20facing%20each%20other%20in%20a%20rainy%20street%20scene%2C%20warm%20golden%20and%20cool%20contrasting%20lighting%2C%20film%20grain%20texture%2C%20dark%20moody%20atmosphere%2C%20professional%20cinematography%20style%2C%20dramatic%20composition%20with%20shallow%20depth%20of%20field%2C%20no%20text%20overlay&width=600&height=400&seq=hero-poster-02&orientation=landscape"
                    alt="热门电视剧"
                    className="w-full aspect-[3/2] object-cover rounded-xl"
                  />
                  <img
                    src="https://readdy.ai/api/search-image?query=Action%20movie%20scene%20with%20explosive%20dynamic%20lighting%20effects%2C%20warm%20orange%20and%20gold%20color%20palette%2C%20fast%20motion%20blur%20effect%2C%20cinematic%20composition%20inspired%20by%20hollywood%20blockbuster%2C%20dark%20background%20with%20dramatic%20highlight%2C%20professional%20film%20production%20quality%2C%20no%20text&width=600&height=400&seq=hero-poster-03&orientation=landscape"
                    alt="动作大片"
                    className="w-full aspect-[3/2] object-cover rounded-xl"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}